import { showCustomToast } from '../components/common/CustomToast';
import { priceService } from '../services/priceService';

export const showSuccess = (message: string, duration?: number) => {
  showCustomToast.success(message, duration);
};

export const showError = (message: string, duration?: number) => {
  showCustomToast.error(message, duration);
};

export const showInfo = (message: string, duration?: number) => {
  showCustomToast.info(message, duration);
};

export const showWarning = (message: string, duration?: number) => {
  showCustomToast.warning(message, duration);
};

// Special toast for deposit notifications using custom toast
export const showDepositNotification = async (amount: number) => {
  const amountInSOL = amount / 1_000_000_000; // Convert lamports to SOL
  
  try {
    // Get live SOL price
    const solPrice = await priceService.getSOLPrice();
    const amountInUSD = amountInSOL * solPrice;
    
    showCustomToast.success(
      `Your deposit of $${amountInUSD.toFixed(2)} USD (${amountInSOL.toFixed(4)} SOL) has arrived!`,
      7000
    );
  } catch (error) {
    // Fallback to cached/default price
    const fallbackPrice = priceService.getCachedPrice();
    const amountInUSD = amountInSOL * fallbackPrice;
    
    showCustomToast.success(
      `Your deposit of $${amountInUSD.toFixed(2)} USD (${amountInSOL.toFixed(4)} SOL) has arrived!`,
      7000
    );
  }
};
